import { BaseSelectFilter } from '../shared/base-select-filter';

const options = [
  { id: '0', label: 'Portrait', value: 0 },
  { id: '1', label: 'Landscape', value: 1 },
];
export function OrientationFilter({
  autoSelectIfEmpty,
  useContextFn,
  errorMessages = {},
}: {
  autoSelectIfEmpty?: boolean;
  useContextFn: () => {
    orientation: number;
    setOrientation: (value: number) => void;
  };
  errorMessages?: Record<string, string>;
}) {
  const { orientation: value, setOrientation: onChange } = useContextFn();
  const helperText = errorMessages['orientation'];
  return (
    <BaseSelectFilter
      autoSelectIfEmpty={autoSelectIfEmpty}
      label="Orientation"
      options={options}
      value={value}
      onChange={onChange}
      error={!!helperText}
      helperText={helperText}
    />
  );
}
